$(document).ready(function () {
    $('.side-nav-btn .navbar-toggler-icon').click(function () {
        if ((($('.navbar-toggler.side-nav-btn').attr('aria-expanded')) === "false") && ($(window).width() < 768)) {
            $('body').addClass('body--no-scroll');
            $('div.navbar-collapse.side-nav').addClass('animated-slideinleft');
        } else {
            $('body').removeClass('body--no-scroll');
            $('div.navbar-collapse.side-nav').removeClass('animated-slideinleft');
        }
    });
    $('.navbar--osr .side-nav-btn .navbar-toggler-icon').click(function () {
        if ((($('.navbar--osr .navbar-toggler.side-nav-btn').attr('aria-expanded')) === "false") && ($(window).width() < 768)) {
            $('body').addClass('body--no-scroll');
            $('.navbar--osr div.navbar-collapse').addClass('animated-slideinleft');
        } else {
            $('body').removeClass('body--no-scroll');
            $('.navbar--osr div.navbar-collapse').removeClass('animated-slideinleft');
        }
    });
});